// src/components/Footer.js
import React from "react";
import { FaFacebookF, FaLinkedinIn, FaInstagram } from "react-icons/fa";
const logo = "https://pub-b515366b2bdd4fb696b694c901df278b.r2.dev/images/reflex.png";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-top">
        {/* Left Section */}
        <div className="footer-left">
          <div className="footer-logo-wrap">
            <img src={logo} alt="Reflex Logo" className="footer-logo" />
          </div>
          <p className="footer-desc">
            Reflex is a leading company in innovative solutions, providing top-notch services to enhance your business growth.
          </p>

          {/* Social Icons */}
          <div className="footer-social">
            <a
              href="https://www.facebook.com/share/1HAzSaxaa9/?mibextid=wwXIfr"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaFacebookF />
            </a>

            <a
              href="https://www.linkedin.com/company/reflexadvisor/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaLinkedinIn />
            </a>

            <a
              href="https://www.instagram.com/reflexadvisor/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaInstagram />
            </a>
          </div>
        </div>

        {/* Right Section */}
        <div className="footer-right">
          <p><a href="tel:+16478460916">+1 647 846 0916</a></p>
          <p><a href="tel:+16478462411">+1 647 846 2411</a></p>
          <p><a href="mailto:info@reflexadvisor.com">info@reflexadvisor.com</a></p>
          <p>222 Jarvis St, Toronto, ON M5B 2B8, Canada</p>
        </div>
      </div>

      {/* Bottom Section */}
      <div className="footer-bottom">
        <p>©️ {new Date().getFullYear()} Reflex. All rights reserved.</p>
      </div>

      <style>{`
        .footer {
          background: #000;
          color: #ffffff;
          padding: 85px 40px 55px;
          font-family: Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif;
          position: relative;
        }

        .footer-top {
          display: flex;
          justify-content: space-between;
          align-items: flex-start;
          gap: 30px;
          max-width: 1200px;
          margin: 0 auto;
          width: 100%;
        }

        .footer-left, .footer-right {
          flex: 1;
        }

        .footer-logo-wrap {
          margin-bottom: 8px;
        }

        .footer-logo {
          width: 130px;
          height: auto;
          object-fit: contain;
        }

        .footer-desc {
          color: #ffffff;
          max-width: 360px;
          font-size: 17px;
          line-height: 1.4;
          margin-bottom: 18px;
        }

        .footer-social {
          display: flex;
          gap: 15px;
        }

        .footer-social a {
          color: #ffffff;
          font-size: 20px;
          transition: color 0.3s;
        }

        .footer-social a:hover {
          color: #9f3ee5;
        }

        .footer-right {
          text-align: right;
          margin-top: -20px;
        }

        .footer-right p,
        .footer-right a {
          color: #ffffff;
          text-decoration: none;
          font-size: 17px;
          margin-bottom: 4px;
          line-height: 0.6;
        }

        .footer-right a:hover {
          color: #9f3ee5;
        }

        .footer-bottom {
          border-top: 1px solid #333;
          margin-top: 45px;
          padding-top: 18px;
          text-align: center;
          font-size: 14px;
          color: #ffffff;
        }

        @media (max-width: 767px) {
          .footer {
            padding: 60px 25px 40px;
          }

          .footer-top {
            flex-direction: column;
            align-items: flex-start;
            gap: 25px;
          }

          .footer-right {
            text-align: left;
          }

          .footer-desc {
            max-width: 100%;
          }
        }
      `}</style>
    </footer>
  );
};

export default Footer;